<div class="coverage-dynamic"
     [class.coverage-dynamic--bordered]="group.layout === coverageGroupLayoutEnum.Bordered"
     [class.coverage-dynamic--bordered-enabled]="group.layout === coverageGroupLayoutEnum.Bordered && value.enabled"
     [class.coverage-dynamic--bordered-disabled]="!input.acceptance"
     [class.coverage-dynamic--border-bottom]="group.hasBorder"
     [insTooltip]="!input.acceptance ? 'Deze dekking is niet mogelijk in uw situatie' : null"
>
    <div class="coverage-dynamic__left-column">
        <div class="coverage-dynamic__checkbox">
            <wuc-input-checkbox [(ngModel)]="values[currentInputIndex].enabled"
                                (ngModelChange)="propagateChange()"
                                [name]="input.id">&nbsp;
            </wuc-input-checkbox>
        </div>
        <div class="coverage-dynamic__title">
            <label [for]="input.id">{{ input?.data?.title }}</label>
            <wuc-card *ngIf="input?.featured" padding="none" cardStyle="tertiary" class="coverage-dynamic__featured">
                <wuc-text-highlight type="secondary">
                    Meest gekozen
                </wuc-text-highlight>
            </wuc-card>
        </div>
    </div>
    <div class="coverage-dynamic__right-column">
        <wuc-link *ngIf="input?.data?.body || input?.data?.tabs"
                  type="secondary"
                  (clicked)="input?.data?.id === coverageIdEnum.CarDamageInsuranceOccupants ? infoModal(input) : displayInformation(input?.data)">
            meer info
        </wuc-link>
        <wuc-price [price]="input?.price"></wuc-price>
    </div>
</div>
